import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class EnvService {

    //site url
    public siteUrl = '';
    public apiUrl ='';

    //base api url
    public siteApiUrl = '';

    // public apiUrl: string = '';

    //public url
    public publicUrl = '';

    // image url
    public imageUrl = '';

    public second_navigation: boolean;

    //article html url
    public articleImage = '';
    public articleUrl = '';
    public chapterXmlUrl = '';
    public bookXmlImageUrl = '';
    public coverImageUrl = '';
    public articleCoverImage = '';
    public defaultImagePath = '';
    public default_journalCoverImage = '';
    public default_journalLogo = '';
    public default_articleCoverImage = '';
    public default_book_cover_image = '';
    public default_part_cover_image = '';
    public default_chapter_cover_image = '';
    public default_publisherLogo = '';
    public default_banner_image = '';
    public downloadFilePath = '';
    public userProfile = '';
    public editorialImage='';
    public rssFeed = '';
    public applicationMode = '';
    public showAppMode: boolean;
    public clientName = '';
    public bannerImage='';
    public default_article_cover_image_upto_11='';
    public default_article_cover_image_above_11='';
}
